<lds-card
  margin="none"
  padding="none"
  *appLoad="let announcements of announcements$; trackingName: 'announcement-list'">
  <div class="annoucements">
    <!-- annoucements / header -->
    <div class="annoucements__header">
      <div class="annoucements__header-icon">
        <lds-icon name="notification-new" size="md"></lds-icon>
      </div>
      <div class="annoucements__header-text">
        <h4>Announcements</h4>
        <p>From the {{ aggregatorName | uppercase }} Team</p>
      </div>
    </div>

    <!-- annoucements / list -->
    <ul class="annoucements__list">
      <li
        class="annoucements__item"
        *ngFor="let announcement of announcements; first as isFirst">
        <div class="annoucement" (click)="openItem(announcement)">
          <h5 class="annoucement__title">{{ announcement.name }}</h5>

          <ng-container *ngIf="isFirst">
            <div class="annoucement__status">
              <lds-tag appearance="error" label="NEW"></lds-tag>
            </div>
          </ng-container>

          <div class="annoucement__icon">
            <lds-tooltip message="download">
              <lds-icon name="download" size="sm"></lds-icon>
            </lds-tooltip>
          </div>
        </div>
      </li>
    </ul>
  </div>
</lds-card>
